var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"responsive-width d-flex"},[_c('OneModelCard',{staticClass:"model-card mx-4",attrs:{"modelIndex":_vm.modelIndex,"width":500,"height":500}})],1),_c('div',[_c('v-btn',{on:{"click":_vm.onClickDownload}},[_vm._v("다운로드")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }